import Accordion from 'components/commercetools-ui/atoms/accordion';
import { ImageProps } from 'components/commercetools-ui/atoms/image';
import Column from './atoms/column';
import FooterBottom from './footer-bottom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { ExtraLink, FooterColumn, SocialMedia } from './types';
import Divider from './atoms/divider';

export interface Props {
  columns: FooterColumn[];
  logo?: ImageProps;
  logoDescription?: string;
  socialMedia?: SocialMedia[];
  infoText?: string;
  extraLinks?: ExtraLink[];
  showCookieButton?: boolean;
  cookieButtonLabel?: string;
  copyrightTitle?: string;
  copyrightDescription?: string;
}

const Footer: React.FC<Props> = ({
  columns,
  logo,
  logoDescription,
  socialMedia,
  infoText,
  extraLinks,
  showCookieButton,
  cookieButtonLabel,
  copyrightTitle,
  copyrightDescription,
}) => {
  return (
    <footer aria-labelledby="footer-heading" className="w-full bg-bg-inverted">
      {/* Desktop */}
      <div className="container hidden w-full justify-between pb-16 pt-58 md:flex">
        <div className="grid w-full grid-cols-4 gap-x-8">
          {columns?.map((column, index) => (
            <div key={index}>
              <Column
                header={column.header}
                links={column.links ?? []}
                className="flex flex-col items-center lg:items-start"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Mobile */}
      <ul className="flex flex-col md:hidden">
        {columns?.map((column, index) => (
          <li key={index} className="container border-b-2 border-stroke-primary pb-12 pt-16">
            <Accordion
              variant="arrow"
              closedSectionTitle={column.header ?? ''}
              openSectionTitle={column.header}
              buttonClassName="h-24 body-text text-brand-tertiary"
              iconClassName="text-brand-tertiary"
            >
              <div className="mb-16 ml-20 flex flex-row text-14 md:ml-24" key={index}>
                <Column links={column.links ?? []} className="px-0" />
              </div>
            </Accordion>
          </li>
        ))}
      </ul>
      {infoText && (
        <div className="body-text-small container py-16 font-normal leading-5 text-brand-tertiary md:pb-64">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{infoText}</ReactMarkdown>
        </div>
      )}
      <Divider className="container sm:border-t" />
      <FooterBottom
        socialMedia={socialMedia}
        logo={logo}
        logoDescription={logoDescription}
        showCookieButton={showCookieButton}
        extraLinks={extraLinks}
        cookieButtonLabel={cookieButtonLabel}
        copyrightTitle={copyrightTitle}
        copyrightDescription={copyrightDescription}
      />
    </footer>
  );
};

export default Footer;
